angular.module('storefrontApp')
    .component('vcLineItems', {
        templateUrl: 'themes/assets/js/common-components/lineItems.tpl.liquid',
        bindings: {
            items: '=',
            readonly: '<',
        },
        controller: ['$scope', function ($scope) { // eslint-disable-line no-unused-vars
            // const $ctrl = this;
        }],
    });
